import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RedirectToFindJobService {
  private _redirectToFindJobStatus = signal(false);

  redirectToFindJobStatusUpdated = this._redirectToFindJobStatus.asReadonly();

  setRedirectToFindJobStatusUpdated(value: boolean) {
    this._redirectToFindJobStatus.set(value);
  }
}
